var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable max-lines */
/* eslint-disable max-lines-per-function */
/* eslint-disable max-statements */
/* eslint-disable complexity */
import React, { forwardRef, useContext, useState } from 'react';
import cx from 'classnames';
import { ThemeContext } from 'styled-components';
import { Formik, Field } from 'formik';
import { getBPHelpers } from '../../utils/breakpoints';
import { Grid, Typography, Container, Stepper, Button, Modal } from '../';
import * as S from './styles';
var questionIdPrefix = 'question-id-';
export var Quiz = forwardRef(function Quiz(_a, ref) {
    var className = _a.className, name = _a.name, questions = _a.questions, color = _a.color, onQuizExit = _a.onQuizExit, language = _a.language, isBlocked = _a.isBlocked, onQuizSubmit = _a.onQuizSubmit, autoProgress = _a.autoProgress, style = _a.style, rest = __rest(_a, ["className", "name", "questions", "color", "onQuizExit", "language", "isBlocked", "onQuizSubmit", "autoProgress", "style"]);
    var themeContext = useContext(ThemeContext);
    var BPHelpers = getBPHelpers(themeContext.breakpoints);
    var paddingScreenSize = BPHelpers.useScreens();
    var scaleFontScreenSize = BPHelpers.useScreens();
    var scaleFontTypeScreenSize = BPHelpers.useScreens();
    var scaleFontSize = scaleFontScreenSize({
        small: 'medium',
        medium: 'large'
    }, 'small' // due to heading variant
    );
    var scaleFontType = scaleFontTypeScreenSize({
        small: 'body',
        medium: 'body'
    }, 'heading');
    var leftRightPadding = paddingScreenSize({
        small: 'small',
        medium: 'large'
    }, themeContext.spacing.xlarge * 2);
    var headerTopBottomPadding = paddingScreenSize({
        small: 'small',
        medium: 'medium'
    }, 'large');
    var _b = useState(0), activeIndex = _b[0], setActiveIndex = _b[1];
    var _c = useState(false), isAlertOpen = _c[0], setIsAlertOpen = _c[1];
    var currentQuestionId = questions[activeIndex].id;
    var textColor = color && color !== 'white' ? 'white' : 'primary';
    var colorClassName = color ? color + "-color" : false;
    var checkboxColorClassName = color && color !== 'white' ? "is-white" : undefined;
    var rootClass = cx(className, colorClassName);
    var canGoNext = activeIndex < questions.length - 1;
    var canGoBack = activeIndex > 0;
    var formInitialValues = questions.reduce(function (acc, cur) {
        acc["" + questionIdPrefix + cur.id] = '';
        return acc;
    }, {});
    var normalizeFormData = function (values) {
        return Object.keys(values).reduce(function (acc, cur) {
            acc["" + cur.replace(questionIdPrefix, '')] = values[cur];
            return acc;
        }, {});
    };
    var handleNextClicked = function (e) {
        if (canGoNext) {
            e.preventDefault();
            setActiveIndex(activeIndex + 1);
        }
    };
    var handleBackClicked = function (e) {
        if (canGoBack) {
            setActiveIndex(activeIndex - 1);
        }
        else {
            e.stopPropagation();
            setIsAlertOpen(true);
        }
    };
    var renderQuestion = function (question, index) {
        var questionPadding = question.description || question.image ? 3 : 6;
        return (React.createElement(Stepper.Item, { noPadding: true, key: "quizz-question-" + index },
            React.createElement(Container, { flex: true, fullWidth: true, style: { flexGrow: question.image ? 0 : 1 }, direction: 'column' },
                React.createElement(Container, { left: leftRightPadding, right: leftRightPadding, flex: true, bottom: questionPadding, direction: 'column' },
                    React.createElement(S.QuestionText, { weight: 'semibold', variant: 'heading', color: textColor }, question.question),
                    question.questionExplanation && (React.createElement(Typography, { color: textColor, weight: 'semibold', size: 'small', variant: 'heading', as: 'span' }, question.questionExplanation))),
                question.description && (React.createElement(Container, { left: leftRightPadding, right: leftRightPadding, flex: true, bottom: 3 },
                    React.createElement(S.Description, { variant: 'heading', color: textColor }, question.description)))),
            question.image && (React.createElement(S.ImageWrapper, { bottom: 3, flex: true, justifyContent: 'center', alignItems: 'center', left: leftRightPadding, right: leftRightPadding },
                React.createElement("img", { src: question.image, style: { maxWidth: '100%', height: 'auto' } }))),
            React.createElement(Container, { bottom: headerTopBottomPadding },
                React.createElement(Container, { flex: true, fullWidth: true, justifyContent: 'flex-start' },
                    React.createElement(Container, { left: leftRightPadding, right: leftRightPadding, flex: true, fullWidth: true, bottom: 'small' },
                        React.createElement(S.ScaleExplanationText, { color: textColor, size: scaleFontSize, variant: scaleFontType, weight: 'semibold' }, question.scaleExplanationLeft))),
                React.createElement(Container, { flex: true, fullWidth: true, alignItems: 'center', justifyContent: 'space-between' },
                    React.createElement(S.Divider, { className: checkboxColorClassName, size: leftRightPadding }),
                    question.answers.map(function (answer, answerIndex) { return (React.createElement(React.Fragment, { key: "answer-" + index + "-" + answerIndex },
                        React.createElement(Field, { name: "" + questionIdPrefix + question.id, id: "" + questionIdPrefix + question.id + "-answer-" + answer, as: S.QuizzRadio, radioValue: "" + answer, variant: 'radioColored', color: 'white', className: checkboxColorClassName, onClick: autoProgress && handleNextClicked }),
                        answerIndex !== question.answers.length - 1 && React.createElement(S.Divider, { className: checkboxColorClassName }))); }),
                    React.createElement(S.Divider, { className: checkboxColorClassName, size: leftRightPadding })),
                React.createElement(Container, { flex: true, fullWidth: true, justifyContent: 'flex-end' },
                    React.createElement(Container, { left: leftRightPadding, right: leftRightPadding, flex: true, fullWidth: true, justifyContent: 'flex-end', top: 'small' },
                        React.createElement(S.ScaleExplanationText, { color: textColor, size: scaleFontSize, variant: scaleFontType, align: 'right', weight: 'semibold' }, question.scaleExplanationRight))))));
    };
    return (React.createElement(S.Quiz, __assign({ ref: ref, className: rootClass, style: style }, rest),
        React.createElement(S.ContentMask, { active: !isBlocked }),
        React.createElement(Formik, { initialValues: formInitialValues, onSubmit: function (val) { return onQuizSubmit(normalizeFormData(val)); } }, function (_a) {
            var values = _a.values;
            return (React.createElement(S.QuizForm, null,
                React.createElement(Container, { flex: true, top: headerTopBottomPadding, bottom: headerTopBottomPadding, left: leftRightPadding, right: leftRightPadding },
                    React.createElement(Grid, { justifyContent: 'space-between' },
                        React.createElement(Grid.Item, null,
                            React.createElement(Typography, { color: textColor, weight: 'semibold', variant: 'heading', as: 'span', size: 'small' }, name)),
                        React.createElement(Grid.Item, null,
                            React.createElement(Typography, { color: textColor, weight: 'semibold', variant: 'heading', as: 'span', size: 'small' },
                                activeIndex + 1,
                                "/",
                                questions.length)))),
                React.createElement(Stepper, { showButtons: false, adaptive: true, noPadding: true, activeIndex: Number(activeIndex), onChangeHandler: setActiveIndex, isSwipeLeftBlocked: values["" + questionIdPrefix + currentQuestionId] === '' }, questions.map(renderQuestion)),
                React.createElement(Container, { flex: true, bottom: headerTopBottomPadding, left: leftRightPadding, right: leftRightPadding, alignItems: 'center', justifyContent: 'space-between' },
                    React.createElement(Button, { size: 'small', color: color && color !== 'white' ? color : 'black', fullWidth: false, circular: (language && !language.exit) || canGoBack, disabled: language && !language.exit && !canGoBack, onClick: handleBackClicked }, !canGoBack && language && language.exit ? language.exit : React.createElement("span", null, "<")),
                    React.createElement(Button, { size: 'small', color: color && color !== 'white' ? color : 'black', fullWidth: false, circular: canGoNext, disabled: values["" + questionIdPrefix + currentQuestionId] === '', onClick: handleNextClicked, type: canGoNext ? 'button' : 'submit' }, !canGoNext ? language && language.submit : React.createElement("span", null, ">"))),
                React.createElement(Modal, { title: '\uD83D\uDC7B', open: isAlertOpen, closeHandler: function () { return setIsAlertOpen(false); } },
                    React.createElement(Container, { top: 'medium' },
                        React.createElement(Typography, { size: 'large', align: 'center', weight: 'semibold' }, language && language.exitPrompt.text)),
                    React.createElement(Modal.Actions, null,
                        React.createElement(Grid, null,
                            React.createElement(Grid.Item, { small: 6 },
                                React.createElement(Button, { color: 'red', onClick: function () { return setIsAlertOpen(false); } }, language && language.exitPrompt.negative)),
                            React.createElement(Grid.Item, { small: 6 },
                                React.createElement(Button, { color: 'green', onClick: function () {
                                        if (onQuizExit)
                                            onQuizExit(normalizeFormData(values));
                                        setIsAlertOpen(false);
                                    } }, language && language.exitPrompt.positive)))))));
        })));
});
Quiz.defaultProps = {
    language: {
        submit: 'Submit',
        exitPrompt: {
            text: 'Do you really want to exit this quiz?',
            positive: 'Yes',
            negative: 'No'
        }
    },
    isBlocked: false,
    autoProgress: false
};
Quiz.displayName = 'Quiz';
export default Quiz;
//# sourceMappingURL=Quiz.js.map